import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import ProductCard from '../product/ProductCard';

function groupArray(array, groupSize) {
    if (groupSize <= 0) {
        throw new Error("Group size must be greater than 0");
    }
    const result = [];
    for (let i = 0; i < array.length; i += groupSize) {
        result.push(array.slice(i, i + groupSize));
    }
    return result;
}
function Items({ currentItems }) {
    return (
        <div className="filter-list">
            {currentItems &&
                currentItems.map((item) => (
                    <div>
                        <h3>Item #{item}</h3>
                    </div>
                ))}
        </div>
    );
}
function Products({ currentItems }) {

    return (
        <div className='filter-list'>
            {currentItems &&
                groupArray(currentItems, 4).map((group, index) => (
                    <div key={`group-${index}`} className='flex-row'>{group.map((item) => (
                        <ProductCard key={`item-${item.id}`} product={item} />
                    ))}</div>
                ))}

        </div>
    );
}

function ProductPaginated({ itemsPerPage, items }) {

    const [currentItems, setCurrentItems] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % items.length;
        //console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
        setItemOffset(newOffset);
    };

    return (
        <div className='filter-list-body'>
            {/**<Items currentItems={currentItems} /> */}
            <Products currentItems={currentItems} />
            <div className="filter-pagination">
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="filter-pagination.ul"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
            </div>
        </div>
    );
}

export default ProductPaginated;